export default __webpack_public_path__ + "static/media/overview.d9ddbe64.jpg";